import { fetchApi } from "../../../lib/fetchApi";
import { DownloadCsvSource } from "../../../types/DownloadCsvTypes";
import {  Pagination, PaginationFilterDto } from "../../../types/Pagination";
import { downloadCsvFile } from "../../../utils/downloadCsvFile";
import { DeleteProfessionalReasonDto, ProfessionalFormDto, ProfessionalDto, SearchByTextRequestDto } from "../types";


const BASE_URL = "/professional"

export const saveProfessional = async (body: ProfessionalFormDto): Promise<ProfessionalFormDto> => {
    const response = await fetchApi.post(`${BASE_URL}`, body) as ProfessionalFormDto;
    return response;
}

export const updateProfessional = async (id: string, body: ProfessionalFormDto): Promise<ProfessionalFormDto> => {
    const response = await fetchApi.put(`${BASE_URL}/${id}`, body) as ProfessionalFormDto;
    return response;
}

export const deleteProfessional = async (id: number, deleteReason: string): Promise<void> => {
    const body: DeleteProfessionalReasonDto = {
        deleteReason: deleteReason
    };

    await fetchApi.put(`${BASE_URL}/delete/${id}`, body);
};

export const getProfessionals = async (body: PaginationFilterDto): Promise<Pagination<ProfessionalDto>> => {
    const response = await fetchApi.post(`${BASE_URL}/search`,  body) as Pagination<ProfessionalDto>;
    return response;
};

export const getProfessionalsBySearchText = async (body: SearchByTextRequestDto): Promise<ProfessionalFormDto[]> => {
    const response = await fetchApi.post(`${BASE_URL}/searchByText`, body) as ProfessionalFormDto[];
    return response;
};

export const getProfessionalById = async (id: string): Promise<ProfessionalFormDto> => {
    const response = await fetchApi.get(`${BASE_URL}/${id}`) as ProfessionalFormDto;
    return response;
};

export const activeProfessional = async (id: number): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/active/${id}`, null);
}

export const exportCsvProfessional = async (filters: PaginationFilterDto): Promise<void> => {
    try {
        const result = await fetchApi.post<DownloadCsvSource>(`${BASE_URL}/exportCsv`, filters, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        downloadCsvFile(result, "professional_export.csv");
    } catch (error) {
        console.error("Error downloading CSV", error);
    }
};